var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _ellipse, _ellipse2, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 260,
    viewBox: "0 0 160 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.603 248.615C188.897 237.09 149.638 197.508 119.5 194H39.7133C9.57496 197.508 -29.6046 236.957 34.6894 248.483C49.3354 251.795 61.1743 253.505 70.0905 254.292C67.5363 252.444 63.4208 243.293 79.7616 233.968C74.5101 230.936 67.1059 227.881 56.7917 225.05C65.4985 223.337 86.4283 221.078 100.492 225.747C91.3612 228.376 84.6472 231.18 79.7616 233.968C97.3545 244.126 90.7891 254.036 88.5398 254.482C97.5289 253.722 109.591 252.01 124.603 248.615Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7616 233.968C63.4208 243.293 67.5363 252.444 70.0905 254.292L79.7616 254.846C80.9095 254.87 81.9631 254.873 82.9217 254.86C84.6367 254.777 86.5099 254.654 88.5398 254.482C90.7891 254.036 97.3545 244.126 79.7616 233.968Z",
    fill: "#5D5D5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7616 254.846L70.0905 254.292L79.7616 260V254.846Z",
    fill: "#5D5D5D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5398 254.482C88.5044 254.489 88.573 254.48 88.5398 254.482L82.9217 254.86C81.8154 254.913 80.7359 254.824 79.7616 254.846V260L88.5398 254.482Z",
    fill: "#5D5D5D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27 82.5C25.6667 87.8333 21.7 98.3 16.5 97.5C21.1667 102.167 35.1 111.5 53.5 111.5H105.5C123.9 111.5 137.833 102.167 142.5 97.5C137.3 98.3 133.333 87.8333 132 82.5L130.5 73.5L29.5 70.5L27 82.5Z",
    fill: "#3B3D4B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.974 67.5002C129.307 65.8335 134.248 65.6981 136.648 69.6981C139.048 73.6981 135.648 78.6983 133.648 80.6984C131.981 82.1984 129.374 82.7005 122.974 81.5005C119.477 87.6543 108.752 98.972 90.9733 102.454C87.5655 103.121 83.8986 103.501 79.9739 103.501L76.9733 103.502C73.8724 103.502 70.9325 103.266 68.1541 102.837C67.7572 102.776 67.3636 102.711 66.9733 102.642C66.1119 102.49 65.2666 102.319 64.4374 102.132L64.3014 102.101C47.5217 98.2603 37.3588 87.4608 33.9733 81.5025C27.5733 82.7025 24.3144 82.1984 22.6477 80.6984C20.6477 78.6983 17.2477 73.698 19.6477 69.698C22.0477 65.698 27.64 65.8354 30.9733 67.5021C27.3067 50.1689 31.3733 14.8025 76.9733 12.0025C77.6404 12.0012 79.1744 11.999 79.9739 12.0005C125.574 14.8005 129.641 50.167 125.974 67.5002Z",
    fill: "#F8C5AD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9739 103.501L76.9733 103.502C73.8724 103.502 70.9325 103.266 68.1541 102.837C67.7572 102.776 67.3636 102.711 66.9733 102.642L66.0002 113.5C67.8336 117 72.7906 122 79.0002 122C83.5002 122 86.0002 122.5 92.0002 114L90.9733 102.454C87.5655 103.121 83.8986 103.501 79.9739 103.501Z",
    fill: "#F8C5AD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9731 50.9065C95.6398 48.2398 102.373 45.0065 107.973 53.4065",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M132.5 153.5C135.667 165.5 144.7 190.7 155.5 195.5C159.5 199 164.2 206.5 151 208.5C142.833 208.167 124.7 197.9 117.5 159.5L132.5 153.5Z",
    fill: "#F8C5AD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2002 154C24.0335 166 15.0002 191.2 4.2002 196C0.200195 199.5 -4.49981 207 8.7002 209C16.8669 208.667 35.0002 198.4 42.2002 160L27.2002 154Z",
    fill: "#F8C5AD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7861 160.948C43.1195 175.793 40.8106 189.884 38.1475 194C54.6475 196 94.2475 198.8 120.647 194C117.86 189.692 115.461 178.648 113.78 161C118.236 160 128.947 156.7 136.147 151.5C133.27 146.333 126.141 132.9 120.647 120.5C119.981 118 111.647 111 92.0002 109C91.1669 112.167 88.6477 121.5 79.1477 121.5C69.4153 121.5 66.8336 112.167 66.0002 109C47.1474 110.5 38.8141 118 38.1475 120.5C32.6535 132.9 25.525 146.333 22.6475 151.5C29.727 156.613 40.2016 159.889 44.7861 160.948Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9731 50.9065C63.3065 48.2398 56.5731 45.0065 50.9731 53.4065",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79,
    cy: 78,
    rx: 7,
    ry: 5.5,
    fill: "#D28F9B"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79,
    cy: 78,
    rx: 5,
    ry: 3.5,
    fill: "#F7F7F7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4997 0.5C110.666 0.5 124.409 17.0718 129.991 29.9688C133.837 38.8561 130.045 51.396 134.248 60.1208C134.899 61.4735 135.885 62.5062 137.366 63C138.866 63.5 140.366 67 131.866 67.5C124.86 67.9121 121.366 59.6485 121.366 52C121.366 47.2865 120.152 42.6505 117.627 38.5C102.427 44.1 86.1087 30.3333 80.4997 22.5C74.9654 30.2291 58.573 43.7346 43.5365 38.7133C42.0332 42.3906 41.0754 46.7884 40.5 52C39.6607 59.6023 37.1435 67.1827 30.1589 66.5C26.7671 66.1685 24.4913 65.7636 23.004 65.3341C19.3371 64.2753 25.1393 62.1924 26.5245 58.6359C28.068 54.673 27.6323 48.2054 27.9997 44.85C27.9997 37 33.4997 0.5 80.4997 0.5Z",
    fill: "#3B3D4B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9731 53.502C76.9731 57.502 71.973 65.502 78.9731 65.502C84.9731 65.502 80.9731 57.502 78.9731 53.502Z",
    fill: "#DB8861"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson2);
export default __webpack_public_path__ + "static/media/person2.fde3779a82d1c5397687cfab5782a8bd.svg";
export { ForwardRef as ReactComponent };